let getters = {
    all:             state => {
        return state.all;
    },
    cachedAll:       state => {
        return state.cachedAll;
    },
    persons:         state => {
        return state.persons;
    },
    statuses:        state => {
        return state.statuses;
    },
    groups:          state => {
        return state.groups;
    },
    ghostGroup:      state => {
        return state.ghostGroup;
    },
    fullDayAbsences: state => {
        return state.fullDayAbsences;
    },
    partDayAbsences: state => {
        return state.partDayAbsences;
    },
    weekSchedules:   state => {
        return state.weekSchedules;
    },
    updated:         state => {
        return state.updated;
    },
    draggingGroup:   state => {
        return state.draggingGroup;
    },
    canBeManaged:    state => {
        return state.draggingGroup;
    }
};

export default getters;